import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithCustomToken } from 'firebase/auth';
import { auth } from '../firebase/config';

// 덴클 프로그램(에이전트 0.9.1) 임베드 진입점 — /agent-embed?token=커스텀토큰&dest=/transactions
// 규약(서버·에이전트와 합의, 변경 금지):
//  - token: Firebase 커스텀 토큰(issueAgentWebToken CF 발급) → signInWithCustomToken
//  - dest: 로그인 성공 후 이동할 내부 경로 (기본 /transactions)
//  - 성공 시 sessionStorage 'dcEmbedded'='1' (MainLayout이 사이드바·상단 네비 숨김)
//  - 실패 시 /login 폴백. 토큰은 console·localStorage 등 어디에도 남기지 않는다.

// 커스텀 토큰(JWT)의 uid 클레임만 판독 — "이미 같은 계정 로그인이면 재로그인 생략" 판정용
// (서명 검증은 Firebase SDK가 수행. 여기서는 비교 목적의 페이로드 읽기만)
const decodeTokenUid = (token) => {
    try {
        const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        return payload.uid || null;
    } catch (_) {
        return null;
    }
};

function AgentEmbedEntry({ onLogin }) {
    const navigate = useNavigate();
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        // fragment(#token=...&dest=...) 우선 판독 — 에이전트 0.9.1 형식(fragment는 서버 로그에 남지 않음)
        // 기존 쿼리(?token=...) 방식은 하위호환으로 유지. 어느 쪽이든 토큰은 로그·저장 금지 동일 원칙
        const hashRaw = (window.location.hash || '').replace(/^#/, '');
        const hashParams = new URLSearchParams(hashRaw);
        const queryParams = new URLSearchParams(window.location.search);
        const token = hashParams.get('token') || queryParams.get('token');
        let dest = hashParams.get('dest') || queryParams.get('dest') || '/transactions';
        // 내부 경로만 허용 (외부 주소·프로토콜 리다이렉트 방지)
        if (!dest.startsWith('/') || dest.startsWith('//')) dest = '/transactions';

        const enterEmbedded = () => {
            try { sessionStorage.setItem('dcEmbedded', '1'); } catch (_) { /* 세션 저장 불가 환경 — 네비는 진행 */ }
            navigate(dest, { replace: true });
        };
        const fail = () => {
            // 토큰 값은 로그에 남기지 않는다 (환자정보 점검 ②·⑥)
            setFailed(true);
            setTimeout(() => navigate('/login', { replace: true }), 1800);
        };

        // 이미 같은 uid로 로그인돼 있으면 재로그인 생략하고 바로 이동
        const tokenUid = token ? decodeTokenUid(token) : null;
        if (auth.currentUser && tokenUid && auth.currentUser.uid === tokenUid) {
            enterEmbedded();
            return;
        }

        if (!token) { fail(); return; }

        signInWithCustomToken(auth, token)
            .then((cred) => {
                if (onLogin) onLogin(cred.user);
                enterEmbedded();
            })
            .catch(() => fail());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#f8fafc', gap: 14 }}>
            {failed ? (
                <p style={{ fontSize: 14, color: '#dc2626', margin: 0 }}>{'프로그램 연결에 실패했어요. 다시 열어주세요'}</p>
            ) : (
                <>
                    <div style={{ width: 34, height: 34, border: '3px solid #e2e8f0', borderTopColor: '#6366f1', borderRadius: '50%', animation: 'dcEmbedSpin 0.8s linear infinite' }} />
                    <p style={{ fontSize: 13.5, color: '#64748b', margin: 0 }}>{'연결 중…'}</p>
                    <style>{`@keyframes dcEmbedSpin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                </>
            )}
        </div>
    );
}

export default AgentEmbedEntry;
